/*
 * Groessen-Dropdown der PDP.
 *
 * Das Dropdown ist reine Oberflaeche: Die Zeilen schreiben ihre Auswahl in die
 * ausgeblendeten Selects aus product-variants.liquid und feuern dort ein
 * change-Event. Variantenermittlung, Verfuegbarkeit, Warteliste und der
 * eigentliche Add-to-Cart laufen unveraendert ueber bs-product-variants.js und
 * application.js.
 *
 * "Notify me" oeffnet unser eigenes BIS-Popup. Die Anmeldung geht an die
 * Klaviyo Client API — nicht an das onsite-iframe, das ohne geladene
 * Produktdaten abstuerzt.
 */
(() => {
	'use strict';

	const OPEN_CLASS = 'is-open';
	const ACTIONS_OPEN_CLASS = 'bs-size-dropdown-open';

	function initSizeDropdown() {
		const buyRow = document.querySelector('[data-js-buy-row]');
		const dropdown = buyRow ? buyRow.querySelector('[data-js-size-dropdown]') : null;
		const productForm = document.querySelector('form.product-form-main');

		if (!buyRow || !dropdown || !productForm) return;

		const isStatic = dropdown.hasAttribute('data-static');
		const trigger = dropdown.querySelector('[data-js-size-trigger]');
		const triggerLabel = dropdown.querySelector('[data-js-size-trigger-label]');
		const list = dropdown.querySelector('.bs-size-dropdown__list');
		const sizeOptions = Array.prototype.slice.call(dropdown.querySelectorAll('[data-js-size-option]'));
		const errorMessage = buyRow.querySelector('[data-js-size-dropdown-error]');
		const atcButton = buyRow.querySelector('[data-js-dropdown-atc]');
		const variantIdField = productForm.querySelector('select[name="id"]');
		const actionsColumn = buyRow.closest('.section-product__actions');

		function getOptionSelects() {
			const selects = [];
			for (let i = 1; i <= 3; i++) {
				const select = productForm.querySelector('select[name="variant' + i + '"]');
				if (select) selects.push(select);
			}
			return selects;
		}

		function hasCompleteSelection() {
			const selects = getOptionSelects();
			if (!selects.length) return false;
			return selects.every(function (select) {
				return select.value && select.value !== '';
			});
		}

		function hasResolvedVariant() {
			if (!variantIdField || variantIdField.disabled || !variantIdField.value) {
				return false;
			}

			const selectedOption = variantIdField.querySelector(
				'option[value="' + variantIdField.value + '"]'
			);
			if (!selectedOption) return false;

			const selects = getOptionSelects();
			for (let i = 0; i < selects.length; i++) {
				const attr = selectedOption.getAttribute('data-variant' + (i + 1));
				if ((attr || '') !== selects[i].value) return false;
			}

			return true;
		}

		function resolveVariantId() {
			if (typeof productForm.resolveVariantId === 'function') {
				return productForm.resolveVariantId();
			}
			return hasResolvedVariant();
		}

		const defaultErrorText = errorMessage ? errorMessage.textContent.trim() : '';
		const genericAtcError = (errorMessage && errorMessage.getAttribute('data-generic-error')) || defaultErrorText;
		const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

		function showError(message) {
			if (!errorMessage) return;
			errorMessage.textContent = message || defaultErrorText;
			errorMessage.classList.remove('hidden');
		}

		function hideError() {
			if (errorMessage) errorMessage.classList.add('hidden');
		}

		function logAddFailure(response, text) {
			console.warn('[bs-size-dropdown] cart/add.js', {
				status: response ? response.status : null,
				contentType: response && response.headers ? response.headers.get('content-type') : null,
				preview: (text || '').slice(0, 120)
			});
		}

		function addToCart() {
			if (!atcButton || atcButton.classList.contains('is-loading')) return;

			if (!resolveVariantId() || !hasResolvedVariant()) {
				showError();
				updateAtcState();
				openDropdown();
				return;
			}

			atcButton.classList.add('is-loading');
			hideError();

			const formData = new FormData(productForm);
			if (!formData.has('id') && variantIdField.value) {
				formData.append('id', variantIdField.value);
			}

			fetch(cartRoot + 'cart/add.js', {
				method: 'POST',
				headers: { Accept: 'application/json' },
				body: formData
			})
				.then(function (response) {
					return response.text().then(function (text) {
						let data = null;
						try {
							data = JSON.parse(text);
						} catch (err) {
							data = null;
						}

						if (!response.ok || !data) {
							logAddFailure(response, text);
							showError((data && data.description) || genericAtcError);
							return null;
						}
						return data;
					});
				})
				.then(function (data) {
					if (!data) return;
					if (typeof window.countCartItems === 'function') {
						window.countCartItems();
					}
					closeDropdown();
					document.dispatchEvent(new CustomEvent('formProductAdded'));
				})
				.catch(function () {
					showError(genericAtcError);
				})
				.finally(function () {
					atcButton.classList.remove('is-loading');
				});
		}

		function updateAtcState() {
			if (!atcButton) return;

			const isReady = hasCompleteSelection() && hasResolvedVariant();
			atcButton.classList.toggle('is-disabled', !isReady);
			atcButton.setAttribute('aria-disabled', isReady ? 'false' : 'true');
			if (atcButton.dataset.labelAdd) {
				atcButton.textContent = atcButton.dataset.labelAdd;
			}
		}

		function syncActiveOptions() {
			const labels = [];

			sizeOptions.forEach(function (option) {
				const select = productForm.querySelector('select[name="variant' + option.dataset.optionIndex + '"]');
				const isActive = !!select && select.value === option.dataset.value;
				const row = option.closest('[data-js-size-row]');
				option.setAttribute('aria-selected', isActive ? 'true' : 'false');
				if (row) row.classList.toggle('is-active', isActive);
				if (isActive) labels.push(option.dataset.label || option.dataset.value);
			});

			if (triggerLabel) {
				triggerLabel.textContent = labels.length
					? labels.join(' / ')
					: (triggerLabel.getAttribute('data-label-select') || '');
			}

			dropdown.classList.toggle('is-filled', labels.length > 0);
		}

		function selectSize(optionIndex, value) {
			const select = productForm.querySelector('select[name="variant' + optionIndex + '"]');
			if (!select) return false;

			select.value = value;
			select.dispatchEvent(new Event('change', { bubbles: true }));
			resolveVariantId();
			hideError();
			syncActiveOptions();
			updateAtcState();
			return true;
		}

		function openDropdown(options) {
			if (isStatic) {
				if (options && options.showError) {
					showError(options.errorMessage);
				}
				return;
			}

			dropdown.classList.add(OPEN_CLASS);
			if (list) list.hidden = false;
			if (trigger) trigger.setAttribute('aria-expanded', 'true');
			if (actionsColumn) actionsColumn.classList.add(ACTIONS_OPEN_CLASS);
			syncActiveOptions();
			updateAtcState();

			if (options && options.showError) {
				showError(options.errorMessage);
			}
		}

		function closeDropdown() {
			dropdown.classList.remove(OPEN_CLASS);
			if (list) list.hidden = true;
			if (trigger) trigger.setAttribute('aria-expanded', 'false');
			if (actionsColumn) actionsColumn.classList.remove(ACTIONS_OPEN_CLASS);
		}

		function toggleDropdown() {
			if (isStatic) return;
			if (dropdown.classList.contains(OPEN_CLASS)) {
				closeDropdown();
			} else {
				openDropdown();
			}
		}

		productForm.openSizeDrawer = function (options) {
			if (isStatic) {
				buyRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
				return;
			}
			openDropdown(options || {});
			buyRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
		};

		const productActions = buyRow.closest('.section-product__actions');
		const bisModal = productActions ? productActions.querySelector('[data-js-bis-modal]') : null;
		const bisForm = bisModal ? bisModal.querySelector('[data-js-bis-form]') : null;
		const bisSize = bisModal ? bisModal.querySelector('[data-js-bis-size]') : null;
		const bisSizeUi = bisModal ? bisModal.querySelector('[data-js-bis-size-ui]') : null;
		const bisSizeTrigger = bisSizeUi ? bisSizeUi.querySelector('[data-js-bis-size-trigger]') : null;
		const bisSizeLabel = bisSizeUi ? bisSizeUi.querySelector('[data-js-bis-size-label]') : null;
		const bisSizeList = bisSizeUi ? bisSizeUi.querySelector('[data-js-bis-size-list]') : null;
		const bisEmail = bisModal ? bisModal.querySelector('[data-js-bis-email]') : null;
		const bisSubmit = bisModal ? bisModal.querySelector('[data-js-bis-submit]') : null;
		const bisImage = bisModal ? bisModal.querySelector('[data-js-bis-image]') : null;
		const bisStatus = bisModal ? bisModal.querySelector('[data-js-bis-status]') : null;
		const bisSuccessText = (function () {
			const el = bisModal && bisModal.querySelector('[data-js-bis-success]');
			return el ? el.textContent.trim() : '';
		})();
		const bisErrorText = (function () {
			const el = bisModal && bisModal.querySelector('[data-js-bis-error]');
			return el ? el.textContent.trim() : '';
		})();

		function syncBisSizeUi() {
			if (!bisSize) return;
			const option = bisSize.options[bisSize.selectedIndex];
			if (bisSizeLabel) {
				bisSizeLabel.textContent = option ? option.textContent.trim() : '';
			}
			if (!bisSizeList) return;
			const value = bisSize.value;
			bisSizeList.querySelectorAll('[data-js-bis-size-row]').forEach(function (row) {
				const button = row.querySelector('[data-js-bis-size-option]');
				const selected = !!(button && button.getAttribute('data-value') === value);
				row.classList.toggle('is-active', selected);
				row.setAttribute('aria-selected', selected ? 'true' : 'false');
			});
		}

		function setBisSizeOpen(open) {
			if (!bisSizeUi || !bisSizeList || !bisSizeTrigger) return;
			bisSizeUi.classList.toggle('is-open', open);
			bisSizeList.hidden = !open;
			bisSizeTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
		}

		function syncBisImage() {
			if (!bisImage) return;
			const option = bisSize && bisSize.options[bisSize.selectedIndex];
			const src = (option && option.getAttribute('data-image'))
				|| (buyRow && buyRow.getAttribute('data-bis-image'))
				|| bisImage.getAttribute('data-default-src')
				|| '';
			if (src) {
				bisImage.src = src;
				bisImage.hidden = false;
				bisImage.removeAttribute('hidden');
			} else {
				bisImage.hidden = true;
			}
		}

		function syncBisSubmit() {
			if (!bisEmail || !bisSubmit) return;
			const ready = /@/.test(bisEmail.value.trim()) && !!bisSize.value;
			bisSubmit.disabled = !ready;
			bisSubmit.classList.toggle('is-email-empty', !ready);
		}

		function setBisStatus(message, type) {
			if (!bisStatus) return;
			if (!message) {
				bisStatus.hidden = true;
				bisStatus.textContent = '';
				bisStatus.className = 'bs-bis__status';
				return;
			}
			bisStatus.hidden = false;
			bisStatus.textContent = message;
			bisStatus.className = 'bs-bis__status is-' + type;
		}

		function openBisModal(variantId) {
			if (!bisModal || !bisSize) return;

			if (variantId && bisSize.querySelector('option[value="' + variantId + '"]')) {
				bisSize.value = variantId;
			}

			if (bisEmail) bisEmail.value = '';
			if (bisSubmit) {
				bisSubmit.hidden = false;
				bisSubmit.disabled = false;
			}
			setBisStatus('', '');
			syncBisSizeUi();
			setBisSizeOpen(false);
			syncBisImage();
			syncBisSubmit();
			if (bisModal.parentNode !== document.body) {
				document.body.appendChild(bisModal);
			}
			bisModal.hidden = false;
			document.body.classList.add('bs-bis-open');
		}

		function closeBisModal() {
			if (!bisModal) return;
			setBisSizeOpen(false);
			bisModal.hidden = true;
			document.body.classList.remove('bs-bis-open');
		}

		function submitBisForm(event) {
			event.preventDefault();
			if (!bisModal || !bisEmail || !bisSize || !bisSubmit) return;

			const email = bisEmail.value.trim();
			const variantId = bisSize.value;
			if (!/@/.test(email) || !variantId) {
				syncBisSubmit();
				return;
			}

			const companyId = bisModal.getAttribute('data-company-id') || 'WWBKpt';
			bisSubmit.disabled = true;
			setBisStatus('', '');

			fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(companyId), {
				method: 'POST',
				headers: {
					revision: '2024-02-15',
					'Content-Type': 'application/json',
					'X-Klaviyo-Onsite': '1'
				},
				body: JSON.stringify({
					data: {
						type: 'back-in-stock-subscription',
						attributes: {
							profile: {
								data: {
									type: 'profile',
									attributes: { email: email }
								}
							},
							channels: ['EMAIL']
						},
						relationships: {
							variant: {
								data: {
									type: 'catalog-variant',
									id: '$shopify:::$default:::' + variantId
								}
							}
						}
					}
				})
			})
				.then(function (response) {
					if (!response.ok) throw new Error('bis');
					setBisStatus(
						bisSuccessText || "You're in! We'll let you know when it's back.",
						'success'
					);
					bisSubmit.hidden = true;
				})
				.catch(function () {
					setBisStatus(
						bisErrorText || 'Something went wrong. Please try again.',
						'error'
					);
					bisSubmit.disabled = false;
				});
		}

		if (bisModal) {
			bisModal.querySelectorAll('[data-js-bis-close]').forEach(function (closeBtn) {
				closeBtn.addEventListener('click', closeBisModal);
			});
			if (bisSizeTrigger) {
				bisSizeTrigger.addEventListener('click', function (event) {
					event.preventDefault();
					setBisSizeOpen(!bisSizeUi.classList.contains('is-open'));
				});
			}
			if (bisSizeList) {
				bisSizeList.addEventListener('click', function (event) {
					const sizeOption = event.target.closest ? event.target.closest('[data-js-bis-size-option]') : null;
					if (!sizeOption || !bisSize) return;
					event.preventDefault();
					bisSize.value = sizeOption.getAttribute('data-value') || '';
					bisSize.dispatchEvent(new Event('change', { bubbles: true }));
					syncBisSizeUi();
					setBisSizeOpen(false);
				});
			}
			document.addEventListener('click', function (event) {
				if (!bisSizeUi || !bisSizeUi.classList.contains('is-open')) return;
				if (bisSizeUi.contains(event.target)) return;
				setBisSizeOpen(false);
			});
			if (bisSize) bisSize.addEventListener('change', syncBisImage);
			syncBisSizeUi();
			if (bisEmail) {
				bisEmail.addEventListener('input', syncBisSubmit);
				bisEmail.addEventListener('change', syncBisSubmit);
			}
			if (bisForm) bisForm.addEventListener('submit', submitBisForm);
			document.addEventListener('keydown', function (event) {
				if (event.key === 'Escape' && !bisModal.hidden) {
					closeBisModal();
				}
			});
		}

		if (trigger) {
			trigger.addEventListener('click', function (event) {
				event.preventDefault();
				if (isStatic) return;
				toggleDropdown();
			});
		}

		dropdown.addEventListener('click', function (event) {
			const notify = event.target.closest ? event.target.closest('[data-js-size-notify]') : null;
			if (!notify) return;

			event.preventDefault();
			event.stopPropagation();
			openBisModal(notify.getAttribute('data-variant-id'));
			closeDropdown();
		});

		buyRow.addEventListener('click', function (event) {
			const waitlist = event.target.closest
				? event.target.closest('[data-js-size-waitlist], [data-js-waitlist-trigger]')
				: null;
			if (!waitlist || waitlist.classList.contains('button--hidden')) return;
			event.preventDefault();
			openBisModal(waitlist.getAttribute('data-variant-id') || (variantIdField && variantIdField.value) || '');
		});

		document.addEventListener(
			'click',
			function (event) {
				const nativeTrigger = event.target.closest ? event.target.closest('.klaviyo-bis-trigger') : null;
				if (!nativeTrigger) return;
				event.preventDefault();
				event.stopImmediatePropagation();
				openBisModal(
					nativeTrigger.getAttribute('data-variant-id') || (variantIdField && variantIdField.value) || ''
				);
			},
			true
		);

		document.addEventListener('click', function (event) {
			if (!dropdown.classList.contains(OPEN_CLASS)) return;
			if (dropdown.contains(event.target)) return;
			if (event.target.closest && event.target.closest('[data-js-sticky-atc]')) return;
			closeDropdown();
		});

		document.addEventListener('keydown', function (event) {
			if (event.key === 'Escape' && dropdown.classList.contains(OPEN_CLASS)) {
				closeDropdown();
			}
		});

		sizeOptions.forEach(function (sizeOption) {
			sizeOption.addEventListener('click', function () {
				selectSize(sizeOption.dataset.optionIndex, sizeOption.dataset.value);
				closeDropdown();
			});
		});

		document.addEventListener(
			'click',
			function (event) {
				const target = event.target.closest ? event.target.closest('[data-js-dropdown-atc]') : null;
				if (!target) return;

				event.preventDefault();
				event.stopImmediatePropagation();

				if (!hasCompleteSelection()) {
					showError();
					updateAtcState();
					if (typeof productForm.openSizeDrawer === 'function') {
						productForm.openSizeDrawer({ showError: true });
					} else {
						openDropdown();
					}
					return;
				}

				addToCart();
			},
			true
		);

		document.addEventListener('variant:change', function () {
			updateAtcState();
			syncActiveOptions();
		});

		document.addEventListener('formProductAdded', function () {
			closeDropdown();
			setTimeout(function () {
				syncActiveOptions();
				updateAtcState();
			}, 50);
		});

		function syncWaitlistLabel() {
			const waitlistButton = buyRow.querySelector('[data-js-size-waitlist]');
			if (waitlistButton && waitlistButton.dataset.labelNotify) {
				waitlistButton.textContent = waitlistButton.dataset.labelNotify;
			}
		}

		syncActiveOptions();
		updateAtcState();
		syncWaitlistLabel();
		setTimeout(syncWaitlistLabel, 500);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initSizeDropdown);
	} else {
		initSizeDropdown();
	}
})();
